import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class GenieRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;

	override async beforeModel(transition: PublicTransition): Promise<void> {
		document.body.id = 'page-genie';

		await this.aiChatService.ensureAvailable(transition);
	}

	override resetController(_controller: Controller, isExiting: boolean): void {
		// Only the genie routes write the thread id, so leaving the tree entirely must clear it. Without this it
		// lingers, and because `activatedRoute` flips to a genie route in routeWillChange — before setupController
		// runs — re-entering genie from elsewhere would briefly report the PREVIOUS thread to the nav sidebar and
		// highlight the wrong row. Mirrors genie/chat/thread/artifact.ts.
		if (isExiting) {
			this.aiChatService.applyUrlThread(null);
		}
	}
}
